export class MDCasteValidityBodyModel {
    constructor(
        public isDocReadable: string,
        public hasBarcode: string,
    ) { }
}